export const defaultAvatarFor = [
    // "men", 
    // "women",
    "lego"
]
export const avatarRight = `https://randomuser.me/api/portraits/${defaultAvatarFor[Math.floor(Math.random()*defaultAvatarFor.length)]}/${Math.floor(Math.random()*9)+1}.jpg`;
export const avatarLeft = `https://randomuser.me/api/portraits/${defaultAvatarFor[Math.floor(Math.random()*defaultAvatarFor.length)]}/${Math.floor(Math.random()*9)+1}.jpg`;
export const STREAM_CHAT_API_KEY = "j2g9djcczjsf";